import { c as _c } from "react/compiler-runtime";
import { YesNo } from "@lib/options";
import { QualificationFormData } from "@modules/booking/context/types";
import { FormProvider, useForm } from "react-hook-form";
import { Form } from "../Form";
import FormSection from "../FormSection";
import PropertyFields from "./PropertyFields";
type PropertyFormValues = Pick<QualificationFormData, "purchasePrice" | "postalCode" | "realEstateAgentFeePercentage"> & {
  hasRealEstateAgentFee: YesNo;
};
interface PropertyFormProps {
  onSubmit: (data: PropertyFormValues) => void;
  canGoBack?: boolean;
  onGoBack?: () => void;
  isLoading?: boolean;
  isError?: boolean;
}
const PropertyForm = t0 => {
  const $ = _c(16);
  const {
    onSubmit,
    canGoBack,
    onGoBack,
    isLoading,
    isError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {};
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const methods = useForm(t1);
  let t2;
  if ($[1] !== methods || $[2] !== onSubmit) {
    t2 = methods.handleSubmit(onSubmit);
    $[1] = methods;
    $[2] = onSubmit;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <PropertyFields />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = <Form id="property-form" onSubmit={t2}>{t3}</Form>;
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== methods || $[8] !== t4) {
    t5 = <FormProvider {...methods}>{t4}</FormProvider>;
    $[7] = methods;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== canGoBack || $[11] !== isError || $[12] !== isLoading || $[13] !== onGoBack || $[14] !== t5) {
    t6 = <FormSection formId="property-form" canGoBack={canGoBack} onGoBack={onGoBack} isLoading={isLoading} isError={isError}>{t5}</FormSection>;
    $[10] = canGoBack;
    $[11] = isError;
    $[12] = isLoading;
    $[13] = onGoBack;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
export default PropertyForm;